import { HOMEWORK_STATUS } from '@/homework/values/homeworks.values';

export const EVENT_TYPES = {
    task: 'Task',
    scroll: 'Scroll',
    text: 'Text',
    cursor: 'Cursor',
    layout: 'Layout',
    video: 'Video',
    resize: 'Resize',
    zoom: 'Zoom',
    whiteboard: 'Whiteboard',
    audio: 'Audio',
    shareTask: 'ShareTask',
    all: 'AllMessages',
    subscribe: 'Subscribe',
    userConnect: 'UserConnect',
    render: 'Render',
    multimediaVideo: 'MultimediaVideo',
    studentConnect: 'StudentConnect',
    studentDisconnect: 'StudentDisconnect',
    changePresenter: 'ChangePresenter',
    changeSlide: 'Slide',
    card: 'Card',
    disconnect: 'Disconnect',
}

export const SCROLL_ELEMENTS = {
    pdf: {
        className: 'ed-file-presentation',
        type: 'pdfViewer'
    },
    responseType: {
        className: 'ed-response-type-object__responses_scroll',  // TODO: Renamed to avoid locking scroll for Type Objects
        type: 'responseType'
    },
    images: {
        className: 'ed-images-viewer',
        type: 'imagesViewer'
    },
    text: {
        className: 'ed-text-viewer',
        type: 'textViewer'
    },
    subdeck: {
        className: 'ed-subdeck-viewer',
        type: 'subdeckViewer'
    },
    deckCard: {
        className: 'ed-deck-card',
        type: 'deckCardViewer'
    }
}

export const SOCKET_EVENTS = {
    events: '/app/interactive/presentationMode.events',
    connect: '/app/interactive/presentationMode.connect',
    connectStudent: '/app/interactive/presentationMode.connectStudent',
    response: '/interactive/topic/',
    requestInformation: '/app/interactive/presentationMode.requestInformation',
    leave: '/app/interactive/presentationMode.leave',
    leaveStudent: '/app/interactive/presentationMode.studentLeave',
    guestTeacherLeave: '/app/interactive/presentationMode.guestTeacherLeave',
    guestTeacherConnect: '/app/interactive/presentationMode.guestTeacherConnect',
    guestTeacherDeclinePresenter: '/app/interactive/presentationMode.guestTeacherDeclinePresenter',
    disconnect: '/app/interactive/presentationMode.disconnect'
}

export const PRESENTATION_MODE_EVENTS = {
    RESPONSE_EVENT: 'RESPONSE_EVENT',
    LEAVE_TEACHER_EVENT: 'LEAVE_TEACHER_EVENT',
    SUSCRIBE_TEACHER_EVENT: 'SUSCRIBE_TEACHER_EVENT',
    LOAD_PRESENTATION_ELEMENTS: 'LOAD_PRESENTATION_ELEMENTS',
    LOAD_ALL_MESSAGES: 'LOAD_ALL_MESSAGES',
    SEND_PENDING_MESSAGES: 'SEND_PENDING_MESSAGES',
    RESPONSE_USER_EVENT: 'RESPONSE_USER_EVENT',
    REFRESH_SATUS: 'REFRESH_SATUS'
}

export const DEFAULT_LAYOUT = 'horizontalLayout';
export const ALERT_COMPONENT = 'EdPresentationModeAlert';
export const SOLUTION_TAB_ID = 'SolutionTab';

export const SEND_MESSAGE_SCROLL_TIMER = 70;
export const SEND_MESSAGE_CURSOR_TIMER = 50;

export const ELEMENT_IDS = {
    COMPONENT: 'component',
    PRESENTATION_COMPONENT: 'presentationComponent',
    CURSOR_CONTAINER: 'cursorContainer',
    COURSE_CONTAINER_INFO: 'courseContainerInfo'
}

export const RATIO_DIRECTIONS =  {
    DECREASE: 'decrease',
    INCREASE: 'increase'
}
export const PRESENTATION_COURSE_TAB_EVENT = 'PRESENTATION_COURSE_TAB_';
export const LOCAL_STORAGE_COURSE_ID_PRESENTATION = 'COURSE_ID_PRESENTATION';
export const ACTIVE_TRANSPARENCY_EVENT = 'ACTIVE_TRANSPARENCY';
export const INACTIVE_TRANSPARENCY_EVENT = 'INACTIVE_TRANSPARENCY';
export const VIEWER_PRESENTATION_TASK = 'EdPresentationModeTask';
export const CHANGE_PRESENTATION_TASK_USER_EVENT = 'CHANGE_PRESENTATION_TASK_USER';
export const SEND_CURRENT_SHARED_TASK_EVENT = 'SEND_CURRENT_SHARED_TASK';
export const CLEAN_CURRENT_SHARED_TASK_EVENT = 'CLEAN_CURRENT_SHARED_TASK_EVENT';
export const RESET_TRANSPARENCY_EVENT = 'RESET_TRANSPARENCY';
export const VALIDATE_PRESENTATION_STUDENT_CONNECT_EVENT = 'VALIDATE_PRESENTATION_STUDENT_CONNECT';
export const SEND_READ_ONLY_STATE_EVENT = 'SEND_READ_ONLY_STATE';
export const RESET_READ_ONLY_EVENT = 'RESET_READ_ONLY';
export const FILTER_PRESENTATION_USERS_EVENT ='FILTER_PRESENTATION_USERS';
export const CLOSE_NAV_MEETING_TOOLS_EVENT = 'CLOSE_NAV_MEETING_TOOLS';
export const CLOSE_MENU_TOOLS_EVENT = 'CLOSE_MENU_TOOLS_EVENT';
export const CLEAR_SELECTED_TOOLBAR_EVENT = 'CLEAR_SELECTED_TOOLBAR';

export const STATUS_CLASSES : {[key: string]: any} = {
    DISCONNECTED: {className: 'gray-alert', title: 'homeworks.disconnected', disabled: false},
    DRAFT_EMPTY: {className: 'red-alert', title: 'homeworks.empty', disabled: false},
    NO_AVAILABLE: {className: 'gray-alert', title: 'homeworks.noAvailable', disabled: true},
    [HOMEWORK_STATUS.DRAFT]: {className: 'yellow-alert', title: 'homeworks.wip', disabled: false},
    [HOMEWORK_STATUS.NEW]: {className: 'green-alert', title: 'homeworks.submitted', disabled: false},
    [HOMEWORK_STATUS.SEEN]: {className: 'green-alert', title: 'homeworks.submitted', disabled: false},
    [HOMEWORK_STATUS.FEEDBACK_DRAFT]: {className: 'green-alert', title: 'homeworks.submitted', disabled: false},
    [HOMEWORK_STATUS.GRADED]: {className: 'green-alert', title: 'homeworks.submitted', disabled: false},
    [HOMEWORK_STATUS.FINISHED]: {className: 'green-alert', title: 'homeworks.submitted', disabled: false}
};

export const ORDER_PENDING_MESSAGES : string [] = [
    EVENT_TYPES.task,
    EVENT_TYPES.resize,
    EVENT_TYPES.layout,
    EVENT_TYPES.zoom,
    EVENT_TYPES.scroll,
    EVENT_TYPES.video,
    EVENT_TYPES.whiteboard,
    EVENT_TYPES.audio,
    EVENT_TYPES.multimediaVideo,
    EVENT_TYPES.shareTask,
    EVENT_TYPES.changeSlide,
    EVENT_TYPES.card
];

export const PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES = {
    OBJECT: 'object',
    BOOLEAN: 'boolean'
}

export const PRESENTATION_MODE_RECONNECT_MESSAGES: Map<string, { [key: string]: string }> = new Map<string, { [key: string]: string }>(
    [
        [EVENT_TYPES.task, { property: 'sectionLoaded', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.OBJECT }],
        [EVENT_TYPES.resize, { property: 'pageSize', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.OBJECT }],
        [EVENT_TYPES.layout, { property: 'layoutValues', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.OBJECT }],
        [EVENT_TYPES.zoom, { property: 'zoomObject', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.BOOLEAN }],
        [EVENT_TYPES.scroll, { property: 'scrollValues', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.OBJECT }],
        [EVENT_TYPES.video, { property: 'videoStateData', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.OBJECT }],
        [EVENT_TYPES.whiteboard, { property: 'whiteboardDocumentInfo', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.OBJECT }],
        [EVENT_TYPES.audio, { property: 'multimediaAudioStateData', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.OBJECT }],
        [EVENT_TYPES.multimediaVideo, { property: 'multimediaVideoStateData', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.OBJECT }],
        [EVENT_TYPES.shareTask, { property: 'shareTaskData', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.OBJECT }],
        [EVENT_TYPES.changeSlide, { property: 'slideData', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.OBJECT }],
        [EVENT_TYPES.card, { property: 'cardData', type: PRESENTATION_MODE_RECONNECT_MESSAGES_TYPES.OBJECT }]
    ]
);

export const GUEST_TACHER_ROLE : string = 'GUEST_TEACHER';
export const TRANSPARENCY_TOOLBAR_HEIGHT = 40;
